import { Icon } from "leaflet"
import React, { Component,Suspense} from "react";
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import {
    Container,Row,  Col,  Button,  Card,  CardBody,  CardTitle,  Modal,  ModalHeader,
    ModalBody,  ModalFooter,  Media,  Table,  Input,  ButtonDropdown,  DropdownToggle,
    DropdownMenu,  DropdownItem,Spinner,  Dropdown, InputGroup} from "reactstrap"

import Select from "react-select"
import Flatpickr from "react-flatpickr"
import { French } from "flatpickr/dist/l10n/fr"
import Timeline from 'react-time-line'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SplineArea from "../AllCharts/apex/SplineArea"
import ColumnWithDataLabels from "../AllCharts/apex/ColumnWithDataLabels"
import $ from "jquery"

import url from "../../common/api"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"
import {getFormatList} from "../../services/formatService.js"
import {getUniteAdministrativeList} from "../../services/uniteAdministrativeService.js"
import {getTypeRessourceList,getCardObject,getColorObject} from "../../services/typeRessourceService.js"
import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {getMotCleList} from "../../services/motCleService.js"
import {getAuteurList} from "../../services/auteurService.js"
import {getPaysList} from "../../services/paysService.js"
import {getProfileRessource,getRessourceByProfile,getRessourceBySearch} from "../../services/ressourceService.js"

import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';
import { MDBDataTable } from "mdbreact"

class Reporting extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedGroupLocalisation: null,
      selectedGroupTypeIrrigation: null,
      selectedGroupLangue: null,
      selectedGroupThematique: null,
      thematique:[],
      localisation:[],
      ressourceData:[],
      thematiqueData:[],
      langueData:[],
      irrigueData:[],
      localisationData:[],
      langue:[],
      unite:[],
      irrigue:[],
      ressource_thematique:[],thematique_choose:false,
      ressource_langue:[],langue_choose:false,
      ressource_localisation:[],localisation_choose:false,
      ressource_irrigation:[],irrigation_choose:false,
      ressource_date:[],
      events:[],
      ressource:[],
      ressource_exploite:[],
      sous_type_ressource:[],
      nombre_ressource:0,
      nombre_evenement:0,
      nombre_expert:0,
      array_filter:{},
      x:[],y:[],chargement:false,recherche:true,Y:[],X:[],
      date_choose:false,fetchChart:true,
      spine:"",time_line:"",chargementChart:false,
      entriesLabelList: ["5"],
      
    }
    this.handleSortBy.bind(this)
    this.handleCountRessourceByMonth.bind(this)
    this.handleSortRessourceExploite.bind(this)
    this.handleSortRessourceRecent.bind(this)
    this.handleFiltreAvance.bind(this)
    this.handleFiltreAvanceLangue.bind(this)
    this.handleFiltreAvanceType.bind(this)
    this.handleFiltreAvanceThematique.bind(this)
    this.handleFiltreAvanceLocalisation.bind(this)
    this.handleFiltreAvanceMotCle.bind(this)
    this.handleFiltreAvanceFormat.bind(this)
    this.handleFiltreAvanceUnite.bind(this)
    this.handleFiltreAvanceAuteur.bind(this)
    this.handleFiltreAvanceTypeRessource.bind(this)
    this.handleDateInterval.bind(this)
  }

  handleSelectGroupLocalisation = selectedGroupLocalisation => {
    this.setState({ selectedGroupLocalisation })
  }
  handleSelectGroupTypeIrrigation = selectedGroupTypeIrrigation => {
    this.setState({ selectedGroupTypeIrrigation })
  }
  handleSelectGroupLangue = selectedGroupLangue => {
    this.setState({ selectedGroupLangue })
  }
  handleSelectGroupThematique = selectedGroupThematique => {
    this.setState({ selectedGroupThematique })
  }

handleSortBy=(data,key)=>{
   _.sortBy(data,""+key+"")
}


handleSortRessourceExploite=(data,limit)=>{
  var ressource=[]
  data.map((element,idx)=>{
          
    if(idx<limit){
      ressource.push(data[data.length-1-idx])
     this.setState({ ressource_exploite:ressource})
    }
   
  })
}

handleCountRessourceByMonth=(data)=>{
  var ressource={}
  data.map((element,idx)=>{
    ressource[element.created_at] = ressource[element.created_at] ? ressource[element.created_at]+1 : 1;
    
  })

  return ressource;
}




handleSortRessourceRecent=(data,limit)=>{
  var ressource=[]
  this.setState({fetchChart:true,events:ressource})
  data.map((element,idx)=>{
    console.log("x",this.state.x)
    if(idx<limit){
      this.setState({ events:[...this.state.events,{ts:data[data.length-idx-1].created_at,text:data[data.length-idx-1].nom}] })

      this.setState({time_line:<Timeline items={this.state.events} format="hh:mm a" />})
    }
   
  })
}

  handleChargerData=()=>{
    var data=JSON.parse(sessionStorage.getItem("authAshia")).profile
    var ressource=[]
    
    fetch(url+"profiles/"+data.id)
       .then((response) => response.json())
       .then((data) => {
         
        var data_trie_date=_.sortBy(data.ressources, 'created_at')
        var data_trie_vue=_.sortBy(data.ressources, 'nombre_vue')
         this.setState({ressourceData:data.ressources,ressource:data.ressources,nombre_expert: data.utilisateurs.filter(e=>e.fonction=="EXPERT").length,nombre_evenement:data.evenements.length,nombre_ressource:data.ressources.length})
      
         this.handleSortRessourceRecent(data_trie_date,6)
         this.handleSortRessourceExploite(data_trie_vue,5)
         this.setState({chargement:true,chargementChart:true,spine:<SplineArea event={data.ressources}/>})
    
        }
        
       );
   }
 


  componentDidMount() {
    this.handleChargerData()
  }

  handleDuBouttonRecherche = () => {
    $("#default-recherche").hide()
    $("#charge-recherche-avance").show()
    getLanguageList().then(e=>this.setState({langue:e}))
    getPaysList().then(e=>this.setState({localisation:e}))
    getThematiqueList().then(e=>this.setState({thematique:e}))
    getMotCleList().then(e=>this.setState({motcle:e}))
    getFormatList().then(e=>this.setState({format:e}))
    getTypeSystemeIrrigueList().then(e=>this.setState({irrigue:e}))
    getAuteurList().then(e=>this.setState({auteur:e}))
    getTypeRessourceList().then(e=>this.setState({type_ressource:e}))
   
    setTimeout(()=>{
      $("#btn-filtre").hide()
      $("#default-recherche").show()
      $("#charge-recherche-avance").hide()
      $("#leFiltre").css("display","block")
      $(".laRecherche").css("display","none")
      }, 3000);
  
   
  }

  handleFiltreAvanceLocalisation = (e) => {
   var unite=[]
    try{

      e.map((element,idx)=>{
  
        element.unite_administratives.map((el)=>{
          unite=[...unite,{value:el.id,label:el.libelle}]
        
          this.setState({unite:unite})
        })
      })

      var pay_ids=e.map((val)=>val.value)
      this.state.array_filter["pays"]=pay_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["pays"]
       this.setState({array_filter:this.state.array_filter}) 
     }
  
  }
  
  handleFiltreAvanceLangue = (e) => {
  
  
    try{
     var langue_ids=e.map((val)=>val.value)
     this.state.array_filter["langue"]=langue_ids
     this.setState({array_filter:this.state.array_filter})
     
    }catch(ee){
      delete this.state.array_filter["langue"]
      this.setState({array_filter:this.state.array_filter}) 
    }
  
  }
  
  handleFiltreAvanceType = (e) => {
    try{
      var system_ids=e.map((val)=>val.value)
      this.state.array_filter["type_systeme_irrigue"]=system_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["type_systeme_irrigue"]
       this.setState({array_filter:this.state.array_filter}) 
     }
  
  }
  
  handleFiltreAvanceThematique = (e) => {
    try{
      var thematique_ids=e.map((val)=>val.value)
      this.state.array_filter["thematique"]=thematique_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["thematique"]
       this.setState({array_filter:this.state.array_filter}) 
     }
   
  
  }
  
  handleFiltreAvanceMotCle=(e)=>{
    try{
      var mot_ids=e.map((val)=>val.value)
      this.state.array_filter["mot_cle"]=mot_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["mot_cle"]
       this.setState({array_filter:this.state.array_filter}) 
     }
  
  }
  handleFiltreAvanceFormat=(e)=>{
  
    try{
      var format_ids=e.map((val)=>val.value)
      this.state.array_filter["format"]=format_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["format"]
       this.setState({array_filter:this.state.array_filter}) 
     }
  
  
  }
  handleFiltreAvanceUnite=(e)=>{
  
    try{
      var unite_ids=e.map((val)=>val.value)
      this.state.array_filter["unite_administrative"]=unite_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["unite_administrative"]
       this.setState({array_filter:this.state.array_filter}) 
     }
  
  
  }
  
  handleFiltreAvanceAuteur = (e) => {
  
    try{
      var auteur_ids=e.map((val)=>val.value)
      this.state.array_filter["auteur"]=auteur_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["auteur"]
       this.setState({array_filter:this.state.array_filter}) 
     }
   
  
  }
  
  handleFiltreAvanceTypeRessource=(e)=>{
    var sous_type=[]
    try{
      var type_ids=e.map((val)=>val.value)

      e.map((element,idx)=>{
  
  
        element.sous_types.map((el)=>{
          sous_type=[...sous_type,{value:el.id,label:el.libelle}]
          this.setState({sous_type_ressource:sous_type})
        })})



      this.state.array_filter["type_ressource"]=type_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["type_ressource"]
       this.setState({array_filter:this.state.array_filter}) 
     }
   
  }
  
  handleFiltreAvanceSousTypeRessource=(e)=>{
    try{

      var sous_type_ids=e.map((val)=>val.value)
      this.state.array_filter["sous_type_ressource"]=sous_type_ids
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["sosu_type_ressource"]
       this.setState({array_filter:this.state.array_filter}) 
     }
  }
  
  

  handleDateInterval= (date)=> {
 
    var data=[]
    this.setState({ressource_date:data})
    if(date.length==2){
      try{
      
        this.state.array_filter["date1"]=new Date(date[0])
        this.state.array_filter["date2"]=new Date(date[1])
        this.setState({array_filter:this.state.array_filter})
        
       }catch(ee){
         delete this.state.array_filter["date1"]
         delete this.state.array_filter["date2"]
         this.setState({array_filter:this.state.array_filter}) 
       }
      // this.setState({date_choose:true})
      // const NewDate1= date[0];
      // const NewDate2= date[1];
      // var tab= this.state.ressourceData.filter(dt=>(new Date(dt.date_edition))>=NewDate1 && (new Date(dt.date_edition))<=NewDate2)
      // this.setState({ressource_date:tab})
    }
  
    
  }

  handleFiltreAvance=()=>{
    $("#data-recherche").show()
    $("#recherche").hide()
   
    var id_profile=JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id
    var filter=this.state.array_filter
    filter["profile_id"]=[id_profile]

    if(localStorage.getItem("private_id") && localStorage.getItem("private_id")!==id_profile){
      filter["profile_id"].push(localStorage.getItem("private_id"))
    }
  
    this.setState({array_filter:filter,ressource:[]})

    this.setState({recherche:false,fetchChart:false,spine:"",time_line:""})
    setTimeout(()=>{
      this.handleTraiterRechercher() 
      }, 3000);
    
  }
  

  handleTraiterRechercher=()=>{
    var ressource=[]

    getRessourceBySearch(this.state.array_filter).then(data=>{
      this.setState({ressource:_.uniqBy(data,'id')})
      var data_trie_date=_.sortBy(data, 'created_at')
      var data_trie_vue=_.sortBy(data, 'nombre_vue')
      this.setState({nombre_ressource:data.length})
      console.log("ressss====+>",data)
      this.handleSortRessourceRecent(data_trie_date,6)
      this.handleSortRessourceExploite(data_trie_vue,5)

      this.setState({recherche:true,spine:<SplineArea event={data}/>})
    })
    
   
  
 }

 loading = () => <Spinner animation="grow" />

  render() {

    const { pick } = this.state
    const { selectedGroupLocalisation } = this.state
    const { selectedGroupTypeIrrigation } = this.state
    const { selectedGroupLangue } = this.state
    const { selectedGroupThematique } = this.state

    const optionGroup = [
      {
        label: "Label",
        options: [
          { label: "Test", value: "Test" },
        ]
      },
      {
        label: "Label",
        options: [
          { label: "Test", value: "Test" },
        ]
      }
    ]

    const events = [
        {ts: "2017-09-17T12:22:46.587Z", text: 'Test'},
        {ts: "2017-09-17T12:21:46.587Z", text: 'Test'},
        {ts: "2017-09-17T12:20:46.587Z", text: 'Test'},
        {ts: "2017-09-16T12:22:46.587Z", text: 'Test'},
        {ts: "2017-09-16T12:21:46.587Z", text: 'Test'},
        {ts: "2017-09-16T12:20:46.587Z", text: 'Test'},
    ];
    const events2 = [
        { text: 'Test'},
        { text: 'Test'},
        { text: 'Test'},
        { text: 'Test'},
        { text: 'Test'},
        { text: 'Test'},
    ];
    
    const animatedComponents = makeAnimated();

    const dataTest = [
      {
        value: 1, 
        label:"Test 1"
      },
      {
        value:2, 
        label:"Test 2"
      },
      {
        value:3, 
        label:"Test 3"
      }
    ];

    const data = {
      columns: [
        {
          label: "Titre",
          field: "nom",
          sort: "asc",
          width: 150,
        },
        {
          label: <i style={{color:"#6A7172"}} className="fa fa-eye "></i>,
          field: "nombre_vue",
          sort: "asc",
          width: 100,
        },
        {
          label: <i style={{color:"#6A7172"}} className="fa fa-download "></i>,
          field: "nombre_telecharge",
          sort: "asc",
          width: 100,
        },
      ],
      // rows:this.state.ressource_.sortBy(this.state.ressource, 'created_at').reverse()
      rows:this.state.ressource_exploite
    }


    return (
      <React.Fragment>
     {
       (this.state.chargement)?
       (<>
        <div className="page-content">
            <MetaTags>
                <title>Reporting | SIS</title>
            </MetaTags>
            <div className="container-fluid ">
              <Breadcrumbs title="Reporting" breadcrumbItem="Reporting" />

              <Card style={{borderRadius:"25px" ,borderColor:"#032e87",borderWidth:"5px"}}>
                <CardBody>

                <Row className="mt-2" id="btn-filtre">
                    <Col lg="8" md="6" sm="12" className="mb-1">
                   
                    </Col>

                    <Col lg="4" md="6" sm="12" >
                      <div >
                        <button id="default-recherche" type="button" style={{backgroundColor:"#5FC4E1",float:"right",borderRadius:"40px"}} className="btn btn-info btn-elegant" onClick={this.handleDuBouttonRecherche}>
                          
                          <i className="fa fa-search pr-2" aria-hidden="true"></i> Filtrer
                        </button>

                      <Button variant="success"
                          disabled
                          id="charge-recherche-avance"
                          style={{borderColor:"#aad29a",float:"right",borderRadius:"10px",display:"none"}}
                        >
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Chargement ...
                      </Button>
                      
                      </div>
                    </Col>
                  </Row>



                <div id="leFiltre" style={{display:"none"}}>
                <label className="mt-3"><strong>FILTRE</strong></label>
                <Row className="mt-3">
                  <Col md="4" lg="4">
                    <label>Thématique(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceThematique}
                      options={this.state.thematique}
                      placeholder="Choisir le/les thématique(s)"
                    />
                  </Col>

                  <Col md="4">
                    <label>Format(s)</label> 
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceFormat}
                      options={this.state.format}
                      placeholder="Choisir le/les format(s)"
                    />
                  </Col>
                  
                  <Col md="4" lg="4">
                    <label>Intervalle de date d'édition</label>
                    <div className="docs-datepicker">
                      <InputGroup>
                        <Flatpickr
                          value={pick}
                          className="form-control d-block"
                          placeholder="Sélectionnez un intervalle de date d'édition"
                          options={{
                            locale:French,
                            mode: "range",
                            altInput: true,
                            // altFormat: "F j, Y",
                            dateFormat: "d-m-y"
                          }}
                          onChange={this.handleDateInterval}
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-outline-secondary docs-datepicker-trigger"
                            disabled
                          >
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </InputGroup>
                      <div className="docs-datepicker-container" />
                    </div>
                  </Col>
                </Row>

                
                <Row className="mt-3">
                  <Col md="4" lg="4">
                    <label>Pays(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceLocalisation}
                      options={this.state.localisation}
                      placeholder="Choisir le/les pays(s)"
                    />
                  </Col>
                  {
                    this.state.unite.length?
                  <Col md="4">
                    <label>Unité(s) administrative</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceUnite}
                      options={_.uniqBy(this.state.unite, 'label')}
                      placeholder="Choisir la/les unité(s) administrative"
                    />
                  </Col>:null
                   }

                  <Col md="4" lg="4">
                    <label>Langue(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceLangue}
                      options={this.state.langue}
                      placeholder="Choisir la/les langue(s)"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="4">
                    <label>Type(s) de système(s) d'irrigation</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceSysteme}
                      options={this.state.irrigue}
                      placeholder="Choisir le/les type(s) de système(s) d'irrigation"
                    />
                  </Col>
                  <Col md="4">
                    <label>Mot(s) clé</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                       onChange={this.handleFiltreAvanceMotCle}
                        options={this.state.motcle}
                      placeholder="Choisir le/les mot(s) clé"
                    />
                  </Col>
                  <Col md="4">
                    <label>Auteur(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                       onChange={this.handleFiltreAvanceAuteur}
                        options={this.state.auteur}
                      placeholder="Choisir le/les auteur(s)"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="6" lg="6">
                    <label>Type de ressource(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceTypeRessource}
                      options={this.state.type_ressource}
                      placeholder="Choisir le/les type(s) de ressource(s)"
                    />
                  </Col>
                  {
                    this.state.sous_type_ressource.length?
                  <Col md="6" lg="6">
                    <label>Sous-type de ressource(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceSousTypeRessource}
                      options={_.uniqBy(this.state.sous_type_ressource, 'label')}
                      placeholder="Choisir le/les sous-type(s) de ressource(s)"
                    />
                  </Col>:null
                  }
                </Row>

          
                <Row className="mt-4">
                  <Col className="col-10"></Col>
                  <Col className="col-1">
                    <button className="btn btn-success " onClick={this.handleFiltreAvance} style={{backgroundColor:"#aad29a", borderColor:"#aad29a",borderRadius:"10px"}}>Chercher</button>
                  </Col>
                </Row>
                </div>

                </CardBody>
              </Card>
          {
            (this.state.recherche)?
            (<>
             {
               this.state.chargementChart?
            (<>
            <Row>
              

              <Col lg={12}>
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <CardTitle className="mb-4"> </CardTitle>
                        {/* <Row>
                            <Col><p><strong>NOMBRE D'UTILISATEUR</strong></p></Col>
                            <Col><strong></strong><span style={{backgroundColor:"#6A7172"}} class="badge rounded-pill ">None</span></Col>
                        </Row> */}
                        <Row>
                          <Col><strong><p>NOMBRE DE RESSOURCES</p></strong></Col>
                          <Col><strong><span style={{backgroundColor:"#6A7172"}} class="badge rounded-pill ">{this.state.ressource.length}</span></strong></Col>
                        </Row>
                        <Row>
                          <Col><p><strong>NOMBRE D'EVENEMENTS</strong></p></Col>
                          <Col><strong></strong><span style={{backgroundColor:"#6A7172"}} class="badge rounded-pill ">{this.state.nombre_evenement}</span></Col>
                        </Row>
                        <Row>
                          <Col><p><strong>NOMBRE D'ACTEURS</strong></p></Col>
                          <Col><strong></strong><span style={{backgroundColor:"#6A7172"}} class="badge rounded-pill ">{this.state.nombre_expert}</span></Col>
                        </Row>
                        {/* <Row>
                            <Col><p><strong>NOMBRE D'EXPERTS</strong></p></Col>
                            <Col><strong></strong><span style={{backgroundColor:"#6A7172"}} class="badge rounded-pill ">None</span></Col>
                        </Row> */}
                  </CardBody>
                </Card>
              </Col>


              {/* Taux de frequentation de la ressource */}
              {/* <Col lg={6}>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-2">
                    TAUX DE FREQUENTATION{" "}
                    </CardTitle>
                    <ColumnWithDataLabels />
                  </CardBody>
                </Card>
              </Col> */}

              

            </Row>

            <Row>
              <Col lg={12}>
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <CardTitle className="mb-2">
                      PUBLICATION DE RESSOURCES{" "}
                    </CardTitle>
                    {
                      this.state.fetchChart?(
                        this.state.spine
                      ):null
                    }
                        
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <CardTitle className="mb-4">
                      DERNIERES RESSOURCES AJOUTEES{" "}
                    </CardTitle>
                    {
                      this.state.fetchChart?(
                        this.state.time_line
                      ):null
                    }
                        
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                {/* <Card>
                  <CardBody>
                    <CardTitle className="mb-2">
                      LES PLUS EXPLOITES{" "}
                    </CardTitle>
                        <Timeline items={events2} format="hh:mm a" />
                  </CardBody>
                </Card> */}
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                    <CardBody>
                        <CardTitle className="mb-4 h4"> LES RESSOURCES LES PLUS EXPLOITEES</CardTitle>
                        <div className="text-center">
                        <div className="mb-4">
                            <i className="bx bx-group display-5" style={{ lineHeight : '1',color:"#5FC4E1"}}/>
                        </div>
                        {/* <h5>1,456</h5> */}
                        <p></p>
                        </div>
                        <Suspense fallback={this.loading()}>
                          <MDBDataTable sortable={false} responsive style={{textAlign:"justify"}} striped entries="5" entrieslabel="5" entriesOptions={this.state.entriesLabelList} maxHeight="200px" searching={false} bordered data={data} />
                        </Suspense>
                        {/* <div className="table-responsive mt-4">
                          <table className="table align-middle table-nowrap">
                            <thead>
                              <tr>
                                <th>
                                  Nom
                                </th>
                                <th>
                                  <i style={{color:"#6A7172"}} className="fa fa-eye "></i>
                                </th>
                                <th>
                                  <i style={{color:"#6A7172"}} className="fa fa-download "></i>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                             {
                               this.state.ressource_exploite.map((element)=>(
                              <tr>
                                  <td style={{ width: "25%" }}>
                                    {element.nom}
                                  </td>
                                  <td>
                                    <span style={{backgroundColor:"#6A7172"}} class="badge rounded-pill ">{element.nombre_vue}</span>
                                  </td>
                                  <td>
                                    <span style={{backgroundColor:"#6A7172"}} class="badge rounded-pill ">{element.nombre_telecharge}</span>
                                  </td>
                              </tr>
                               ))
                             }
                            </tbody>
                          </table>
                        </div> */}
                    </CardBody>
                    </Card>
              </Col>
            </Row>
            </>):
            (<>

                 <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <div>Aucune Ressource Trouvée !</div>
                  </CardBody>
                 </Card>   
            </>)

              }

          </>):(
             <div style={{textAlign:"center"}}>
               <Spinner  color="secondary" />
            </div>
             )
        
           }
            </div>
            </div>
            </>):(
             <div style={{marginTop:"250px",textAlign:"center"}}>
               <Spinner type="grow" color="secondary" />
            </div>
        )
        
      }
      </React.Fragment>
    )
  }
}

export default Reporting
